import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

export type Duration = Partial<{
  id: number;
  trip_id: number;
  duration: string;
  _ca: number;
  _cb: number;
  _lma: any;
  _lmb: any;
}>;

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: Array<Duration>;
}>;
type QueryError = {};

const useTripDurationsQuery = (
  tripId: number,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/durations`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url);
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripDurationsQuery;
